import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Checkbox,
  Label,
  Dropdown,
  Button,
  Form,
  FormGroup,
  FormField,
  Input
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardBillingHistoryUX = (props: any) => {
    return(
      <div
        id="CardBillingHistoryUX-div-0"
        style={{ zoom: "90%" }}>
        <div
          id="CardBillingHistoryUX-div-24"
          style={{fontWeight: "bold", fontSize: "1.2rem",padding: "10px 10px 0px 10px", display: "flex", justifyContent: "space-between"}}>
          {props.languageUX === "en" ? "BILLING - HISTORY" : "ประวัติการเรียกเก็บเงิน"}
          <div
            id="CardBillingHistoryUX-div-72">
            {props.languageUX === "en" ? "Medical payment history" : "ประวัติการชำระเงินค่ารักษาพยาบาล"}
          </div>
        </div>
        <div
          id="CardBillingHistoryUX-div-128"
          style={{padding: "0px 10px"}}>
          
          <hr
            id="CardBillingHistoryUX-hr-129">
          </hr>
        </div>
        <div
          id="CardBillingHistoryUX-div-28"
          style={{display:"none", justifyContent:"flex-end",alignItems:"center", padding: "10px 0px 20px 0px"}}>
          
          <Checkbox
            checked={props.divisionCheck}
            id="CardBillingHistoryUX-Checkbox-29"
            label={props.languageUX === "en" ? "Agency" : "หน่วยงาน"}
            onChange={props.onChangeDivisionCheck}
            style={{padding:"0px 10px"}}>
          </Checkbox>
          <div
            id="CardBillingHistoryUX-div-81"
            style={{width: "170px", margin: "0px 5px"}}>
            
            <Dropdown
              fluid="true"
              id="CardBillingHistoryUX-Dropdown-82"
              onChange={props.onChangeDivision}
              options={props.division}
              search={true}
              selection={true}
              value={props.divisionSelect}>
            </Dropdown>
          </div>
          <Checkbox
            checked={props.statusCheck}
            id="CardBillingHistoryUX-Checkbox-75"
            label={props.languageUX === "en" ? "status" : "สถานะ"}
            onChange={props.onChangeStatusCheck}
            style={{padding:"0px 5px"}}>
          </Checkbox>
          <div
            id="CardBillingHistoryUX-div-83"
            style={{width: "170px", margin: "0px 5px"}}>
            
            <Dropdown
              fluid="true"
              id="CardBillingHistoryUX-Dropdown-85"
              onChange={props.onChangeStatus}
              options={props.statusOptions}
              selection={true}
              value={props.status}>
            </Dropdown>
          </div>
          <div
            id="CardBillingHistoryUX-div-84"
            style={{width: "170px", margin: "0px 5px"}}>
            
            <Dropdown
              fluid="true"
              id="cb-billingType"
              onChange={props.onChangeType}
              options={props.typeOptions}
              selection={true}
              value={props.type}>
            </Dropdown>
          </div>
          <Checkbox
            checked={props.dateCheck}
            id="CardBillingHistoryUX-Checkbox-78"
            label={props.languageUX === "en" ? "Document issue date" : "วันที่ออกเอกสาร"}
            onChange={props.onChangeDateCheck}
            style={{padding:"0px 5px"}}>
          </Checkbox>
          <DateTextBox
            id="CardBillingHistoryUX-DateTextBox-79"
            onChange={props.onChangeStartDate}
            style={{padding:"0px 5px"}}
            value={props.startDate}>
          </DateTextBox>
          <DateTextBox
            id="CardBillingHistoryUX-DateTextBox-80"
            onChange={props.onChangeEndDate}
            style={{padding:"0px 5px",}}
            value={props.endDate}>
          </DateTextBox>
          <div
            id="CardBillingHistoryUX-div-229">
            {props.buttonSearch}
          </div>
        </div>
        <div
          className={props.formStyle}
          id="CardBillingHistoryUX-div-230"
          style={{width: "100%", margin: "0rem 1rem 1rem"}}>
          
          <Form
            id="CardBillingHistoryUX-Form-245">
            <FormGroup
              className="rps-form-group"
              id="CardBillingHistoryUX-FormGroup-231"
              inline={true}>
              <FormField
                id="CardBillingHistoryUX-FormField-264"
                inline="true">
                <Checkbox
                  checked={props.codeCheck}
                  id="CardBillingHistoryUX-Checkbox-266"
                  label={props.languageUX === "en" ? "Document code" : "รหัสเอกสาร"}
                  onChange={props.onChangeCodeCheck}
                  style={{ minWidth: "max-content" }}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardBillingHistoryUX-FormField-265"
                inline={true}
                width={props.isIpad ? 4 : 2}>
                <Input
                  id="CardBillingHistoryUX-Input-267"
                  onChange={props.onChangeCode}
                  style={{ width: "100%" }}
                  value={props.code}>
                </Input>
              </FormField>
              <FormField
                id="CardBillingHistoryUX-FormField-232"
                inline={true}>
                <Checkbox
                  checked={props.divisionCheck}
                  id="CardBillingHistoryUX-Checkbox-242"
                  label={props.languageUX === "en" ? "Department" : "หน่วยงาน"}
                  onChange={props.onChangeDivisionCheck}
                  style={{ minWidth: "max-content" }}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardBillingHistoryUX-FormField-233"
                inline={true}
                width={props.isIpad ? 4 : 2}>
                <Dropdown
                  fluid={true}
                  id="CardBillingHistoryUX-Dropdown-244"
                  onChange={props.onChangeDivision}
                  options={props.division}
                  search={true}
                  selection={true}
                  style={{ width: "100%" }}
                  value={props.divisionSelect}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardBillingHistoryUX-FormField-234"
                inline={true}>
                <Checkbox
                  checked={props.statusCheck}
                  id="CardBillingHistoryUX-Checkbox-247"
                  label={props.languageUX === "en" ? "status" : "สถานะ"}
                  onChange={props.onChangeStatusCheck}
                  style={{ minWidth: "max-content" }}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardBillingHistoryUX-FormField-235"
                inline={true}
                width={props.isIpad ? 3 : 2}>
                <Dropdown
                  fluid={true}
                  id="CardBillingHistoryUX-Dropdown-254"
                  onChange={props.onChangeStatus}
                  options={props.statusOptions}
                  selection={true}
                  style={{ width: "100%" }}
                  value={props.status}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardBillingHistoryUX-FormField-236"
                inline={true}
                width={props.isIpad ? 4 : 2}>
                <Dropdown
                  fluid={true}
                  id="cb-billingType"
                  onChange={props.onChangeType}
                  options={props.typeOptions}
                  selection={true}
                  style={{ width: "100%" }}
                  value={props.type}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardBillingHistoryUX-FormField-237"
                inline={true}>
                <Checkbox
                  checked={props.dateCheck}
                  id="CardBillingHistoryUX-Checkbox-256"
                  label={props.languageUX === "en" ? "Document  date" : "วันที่ออกเอกสาร"}
                  onChange={props.onChangeDateCheck}
                  style={{ minWidth: "max-content" }}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardBillingHistoryUX-FormField-238"
                inline={true}
                width={props.isIpad ? 5 : 2}>
                <div
                  id="CardBillingHistoryUX-div-251"
                  style={{ width: "100%" }}>
                  
                  <DateTextBox
                    id="CardBillingHistoryUX-DateTextBox-260"
                    onChange={props.onChangeStartDate}
                    value={props.startDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardBillingHistoryUX-FormField-239"
                inline={true}
                width={props.isIpad ? 5 : 2}>
                <div
                  id="CardBillingHistoryUX-div-252"
                  style={{ width: "100%" }}>
                  
                  <DateTextBox
                    id="CardBillingHistoryUX-DateTextBox-261"
                    onChange={props.onChangeEndDate}
                    value={props.endDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardBillingHistoryUX-FormField-240"
                inline={true}>
                <div
                  id="CardBillingHistoryUX-div-259">
                  {props.buttonSearch}
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <Table
          className="--rt-tbody-overflow-y-hidden"
          data={props.billingData}
          getTrProps={props.onSelectedItems}
          headers={props.languageUX === "en" ? "No,Document code,Expense type,Patient,Document issue date,Amount,Status,Department,Shift" : "ลำดับ, รหัสเอกสาร, ประเภทเอกสารค่าใช้จ่าย, ผู้ป่วย, วันที่-เวลา ออกเอกสาร, มูลค่า, สถานะ, หน่วยงาน, กะ"}
          id="tb-billHistory"
          keys="no,code,type_name,patient_name,created,price,status_label,division_name,station_name"
          minRows={7}
          showPagination={false}
          style={{height: "300px",  zoom: "87%", margin: "0px 10px", ...(props.tableStyle || {})}}>
        </Table>
        <div
          id="CardBillingHistoryUX-div-126"
          style={{paddingTop: "20px"}}>
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.edcData}
            headers="Referral Code,Approval Code,Perform Date	,Type,Status,Total Price,Actual Price,Actions"
            id="CardBillingHistoryUX-Table-127"
            keys="reference_code_edited,approval_code_edited,effective_date,approval_type,status,total_price,actual_price,actions"
            minRows={7}
            showPagination={ false}
            style={{display: props.showEDC ? "" : "none", height: "300px",  zoom: "100%", margin: "0px 10px"}}
            widths="auto,auto,auto,auto,auto,auto,auto,220">
          </Table>
        </div>
        <div
          id="CardBillingHistoryUX-div-63"
          style={{paddingTop: "20px", display: props.receiptId === "" ?  "none" : "block", ...(props.selectedReceipt?.type_name === "DEPOSIT" && { display: "none" }) }}>
          
          <div
            id="CardBillingHistoryUX-div-59"
            style={{fontWeight: "bold", fontSize: "1.2rem",padding: "10px", display: "flex", justifyContent: "space-between"}}>
            {props.showBillType === "credit_note" ? "CREDIT NOTE" :  props.showBillType === "invoice" ? "INVOICE" : props.showBillType === "receipt" ? "RECEIPT" : ""}
            <div
              className={props.languageUX === "en" ? "Receipt Information" : "ข้อมูลใบเสร็จค่ารักษาพยาบาล"}
              id="CardBillingHistoryUX-div-62">
              {props.showBillType === "credit_note" ? "ข้อมูลรายการใบสำคัญคืนเงิน" :  "ข้อมูลใบเสร็จค่ารักษาพยาบาล"}
            </div>
          </div>
          <div
            id="CardBillingHistoryUX-div-40"
            style={{display: props?.searchHistorySelected  ? "flex" :"none" ,alignItems:"center", margin: "10px 10px", fontWeight: "normal", fontSize: "1.2rem"}}>
            
            <div
              id="CardBillingHistoryUX-div-41"
              style={{margin: "0px 10px 0px 0px"}}>
              {props.languageUX === "en" ? "Document number" : "เลขที่เอกสาร"}
            </div>
            <Label
              id="CardBillingHistoryUX-Label-51">
              {props.editCode}
            </Label>
            <div
              id="CardBillingHistoryUX-div-43"
              style={{margin: "0px 10px 0px 30px"}}>
              {props.languageUX === "en" ? "encounter" : "encounter"}
            </div>
            <Label
              id="CardBillingHistoryUX-Label-52"
              name={{margin: "0px 20px 0px 0px"}}>
              {props.editEncounter}
            </Label>
            <div
              id="CardBillingHistoryUX-div-45"
              style={{margin: "0px 10px 0px 30px"}}>
              {props.languageUX === "en" ? "physician" : "แพทย์"}
            </div>
            <Label
              id="CardBillingHistoryUX-Label-53"
              name={{margin: "0px 20px 0px 0px"}}>
              {props.editDoctor}
            </Label>
            <div
              id="CardBillingHistoryUX-div-47"
              style={{margin: "0px 10px 0px 30px"}}>
              {props.languageUX === "en" ? "Ordered agency" : "หน่วยงานสั่ง"}
            </div>
            <Label
              id="CardBillingHistoryUX-Label-54"
              name={{margin: "0px 20px 0px 0px"}}>
              {props.editOrderDiv}
            </Label>
            <div
              id="CardBillingHistoryUX-div-49"
              style={{margin: "0px 10px 0px 30px"}}>
              {props.languageUX === "en" ? "Paying agency" : "หน่วยงานจ่าย"}
            </div>
            <Label
              id="CardBillingHistoryUX-Label-55"
              name={{margin: "0px 20px 0px 0px"}}>
              {props.editOrderPerformDiv}
            </Label>
          </div>
          <div
            id="CardBillingHistoryUX-div-151"
            style={{ margin: "0px 10px 10px", ...(props.selectedReceipt?.type_name !== "PAYMENT" && { display: "none" })  }}>
            
            <Form
              id="CardBillingHistoryUX-Form-152">
              <FormGroup
                id="CardBillingHistoryUX-FormGroup-153"
                inline={true}
                style={{ margin: "0px" }}>
                <FormField
                  id="CardBillingHistoryUX-FormField-155"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-167"
                    style={{ fontWeight: "bold", marginRight: "10px" }}>
                    {props.languageUX === "en" ? "Receipt number" : "เลขที่ใบเสร็จ"}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-158"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-170"
                    style={{ fontWeight: "bold", margin: "0px 10px" }}>
                    {props.languageUX === "en" ? "Encounter" : "Encounter"}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-160"
                  width={3}>
                  <div
                    id="CardBillingHistoryUX-div-172"
                    style={{ fontWeight: "bold", margin: "0px 10px" }}>
                    {props.languageUX === "en" ? "Agency" : "หน่วยงาน"}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-157"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-169"
                    style={{ fontWeight: "bold", margin: "0px 10px" }}>
                    {props.languageUX === "en" ? "Date-time" : "วันที่-เวลา"}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-156"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-168"
                    style={{ fontWeight: "bold", margin: "0px 10px" }}>
                    {props.languageUX === "en" ? "Document status" : "สถานะเอกสาร"}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-159"
                  width={4}>
                  <div
                    id="CardBillingHistoryUX-div-171"
                    style={{ fontWeight: "bold", margin: "0px 10px" }}>
                    {props.languageUX === "en" ? "Station" : "Station"}
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardBillingHistoryUX-FormGroup-185"
                inline={true}
                style={{ margin: "0px" }}>
                <FormField
                  id="CardBillingHistoryUX-FormField-186"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-197"
                    style={{ width: "100%", background: "rgb(221, 221, 221)", padding: "3px 10px", marginRight: "10px" }}>
                    {props.selectedReceipt?.code}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-187"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-196"
                    style={{ width: "100%", background: "rgb(221, 221, 221)", padding: "3px 10px", margin: "0px 10px" }}>
                    {props.selectedReceipt?.encounter_no || "-"}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-188"
                  width={3}>
                  <div
                    id="CardBillingHistoryUX-div-195"
                    style={{ width: "100%", background: "rgb(221, 221, 221)", padding: "3px 10px", margin: "0px 10px" }}>
                    {props.selectedReceipt?.division_name}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-189"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-194"
                    style={{ width: "100%", background: "rgb(221, 221, 221)", padding: "3px 10px", margin: "0px 10px" }}>
                    {props.selectedReceipt?.created}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-190"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-193"
                    style={{ width: "100%", background: "rgb(221, 221, 221)", padding: "3px 10px", margin: "0px 10px" }}>
                    {props.selectedReceipt?.status_label}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-191"
                  width={4}>
                  <div
                    id="CardBillingHistoryUX-div-192"
                    style={{ width: "100%", background: "rgb(221, 221, 221)", padding: "3px 10px", margin: "0px 10px" }}>
                    {props.selectedReceipt?.station_name}
                  </div>
                </FormField>
              </FormGroup>
            </Form>
          </div>
          <div
            id="CardBillingHistoryUX-div-198"
            style={{ margin: "0px 10px 10px", ...(props.selectedReceipt?.type_name !== "FULL_PAYMENT" && { display: "none" })  }}>
            
            <Form
              id="CardBillingHistoryUX-Form-199">
              <FormGroup
                id="CardBillingHistoryUX-FormGroup-200"
                inline={true}
                style={{ margin: "0px" }}>
                <FormField
                  id="CardBillingHistoryUX-FormField-202"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-225"
                    style={{ fontWeight: "bold", marginRight: "10px" }}>
                    {props.languageUX === "en" ? "Receipt number" : "เลขที่ใบเสร็จ"}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-203"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-224"
                    style={{ fontWeight: "bold", margin: "0px 10px" }}>
                    {props.languageUX === "en" ? "status" : "สถานะ"}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-204"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-223"
                    style={{ fontWeight: "bold", margin: "0px 10px" }}>
                    {props.languageUX === "en" ? "Date-time" : "วันที่-เวลา"}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-205"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-222"
                    style={{ fontWeight: "bold", margin: "0px 10px" }}>
                    {props.languageUX === "en" ? "Encounter" : "Encounter"}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-206"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-221"
                    style={{ fontWeight: "bold", margin: "0px 10px" }}>
                    {props.languageUX === "en" ? "Admission" : "รับเข้า"}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-207"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-220"
                    style={{ fontWeight: "bold", margin: "0px 10px" }}>
                    {props.languageUX === "en" ? "For sale" : "จำหน่าย"}
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardBillingHistoryUX-FormGroup-201"
                inline={true}
                style={{ margin: "0px" }}>
                <FormField
                  id="CardBillingHistoryUX-FormField-208"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-219"
                    style={{ width: "100%", background: "rgb(221, 221, 221)", padding: "3px 10px", marginRight: "10px" }}>
                    {props.selectedReceipt?.code}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-209"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-218"
                    style={{ width: "100%", background: "rgb(221, 221, 221)", padding: "3px 10px", margin: "0px 10px" }}>
                    {props.selectedReceipt?.status_label}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-210"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-217"
                    style={{ width: "100%", background: "rgb(221, 221, 221)", padding: "3px 10px", margin: "0px 10px" }}>
                    {props.selectedReceipt?.created}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-211"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-216"
                    style={{ width: "100%", background: "rgb(221, 221, 221)", padding: "3px 10px", margin: "0px 10px" }}>
                    {props.selectedReceipt?.encounter_no}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-212"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-215"
                    style={{ width: "100%", background: "rgb(221, 221, 221)", padding: "3px 10px", margin: "0px 10px" }}>
                    {props.receiptEncounterData?.checkIn || "-"}
                  </div>
                </FormField>
                <FormField
                  id="CardBillingHistoryUX-FormField-213"
                  width={2}>
                  <div
                    id="CardBillingHistoryUX-div-214"
                    style={{ width: "100%", background: "rgb(221, 221, 221)", padding: "3px 10px", margin: "0px 10px" }}>
                    {props.receiptEncounterData?.checkOut || "-"}
                  </div>
                </FormField>
              </FormGroup>
            </Form>
          </div>
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.receiptData}
            headers={props.languageUX === "en" ? "Mode code,Medical Mode,Price,Claim submit,absorb,Self-claim,Non-claimable,Discount,Patient pay" : "รหัสหมวด, ชื่อหมวดค่ารักษาพยาบาล, ราคา, ส่งเบิก, รพ.รับผิดชอบ, เบิกเอง, เบิกไม่ได้, ส่วนลด, ผู้ป่วยชำระ"}
            id="CardBillingHistoryUX-Table-2"
            keys="bill_mode__code,bill_mode__name,price__sum,send_claim__sum,absorb__sum,patient_claim__sum,non_claimable__sum,discount__sum,payable__sum"
            minRows={7}
            showPagination={false}
            style={{height: "300px", margin: "0px 10px",  ...(props.tableModeStyle || {}), ...(props.showBillType === "credit_note" && { display: "none"})}}>
          </Table>
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.receiptData}
            getTrProps={props.byOrderRowProps}
            headers={props.languageUX === "en" ? "Division,Order,Type,Expense Datetime, Price,Claim submit, Absorb,Self-claim,Non-claimable,Discount,Patient pay, Expense type,Expense status,Encounter" : "แผนก, ชื่อรายการคำสั่ง, ประเภท, วันที่และเวลาค่าใช้จ่าย, ราคา, ส่งเบิก, รพ.รับผิดชอบ, เบิกเอง, เบิกไม่ได้, ส่วนลด, ผู้ป่วยชำระ, ประเภทค่าใช้จ่าย, สถานะค่าใช้จ่าย,หมายเลขรับบริการ"}
            id="CardBillingHistoryUX-Table-122"
            keys="division__name, display_name, encounter__type, created, price__sum, send_claim__sum, absorb__sum, patient_claim__sum, non_claimable__sum, discount__sum, payable__sum , type__name, status__name, encounter__number"
            minRows={7}
            showPagination={ false}
            style={{height: "300px",  margin: "0px 10px",  ...(props.tableOrderStyle || {}), ...(props.showBillType === "credit_note" && { display: "none"})}}>
          </Table>
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.receiptData}
            headers={props.languageUX === "en" ? "Mode code, item code,Name,QTY,Price/Unit,Total Price,Claim submit, Absorb,Self-claim,Non-claimable,Discount,Patient pay, Discount Policy,Discount code" : "รหัสหมวด, รหัสค่ารักษา, ชื่อรายการค่ารักษาพยาบาล, จำนวน, ราคาต่อหน่วย, ราคา, ส่งเบิก, absorb, เบิกเอง, เบิกไม่ได้, ส่วนลด, ผู้ป่วยชำระ, ส่วนลดสิทธิ, รหัสส่วนลด"}
            id="tb-billHistoryDetails"
            keys="mode_code, code, product, quantity, unitprice, price__sum, send_claim__sum, absorb__sum, patient_claim__sum, non_claimable__sum, discount__sum, payable__sum, drg_discount_amount, discount_code"
            minRows={7}
            showPagination={ false}
            style={{height: "300px",  margin: "0px 10px",  ...(props.tableItemStyle || {}), ...(props.showBillType === "credit_note" && { display: "none"})}}>
          </Table>
          <div
            id="CardBillingHistoryUX-div-87"
            style={{display: "flex", alignItems: "center",padding: "0px 10px", justifyContent: "space-around", paddingTop: "20px", ...(props.showBillType === "credit_note" && { display: "none"})}}>
            
            <div
              id="CardBillingHistoryUX-div-90"
              style={{display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.languageUX === "en" ? "Total price" : "ราคารวม"}
            </div>
            <div
              id="CardBillingHistoryUX-div-91"
              style={{display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.languageUX === "en" ? "Claim submit" : "ส่งเบิก"}
            </div>
            <div
              id="CardBillingHistoryUX-div-92"
              style={{display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.languageUX === "en" ? "absorb" : "รพ.รับผิดชอบ"}
            </div>
            <div
              id="CardBillingHistoryUX-div-93"
              style={{display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.languageUX === "en" ? "Self-Claim" : "เบิกเอง"}
            </div>
            <div
              id="CardBillingHistoryUX-div-94"
              style={{display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.languageUX === "en" ? "Non-claimable" : "เบิกไม่ได้"}
            </div>
            <div
              id="CardBillingHistoryUX-div-95"
              style={{display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.languageUX === "en" ? "Discount" : "ส่วนลด"}
            </div>
            <div
              id="CardBillingHistoryUX-div-96"
              style={{display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.languageUX === "en" ? "Patient pay" : "ผู้ป่วยชำระ"}
            </div>
            <div
              id="CardBillingHistoryUX-div-149"
              style={{display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.languageUX === "en" ? "Installment" : "ผ่อนชำระ"}
            </div>
          </div>
          <div
            id="CardBillingHistoryUX-div-88"
            style={{display: "flex", alignItems: "center",padding: "0px 10px", justifyContent: "space-around", ...(props.showBillType === "credit_note" && { display: "none"})}}>
            
            <div
              id="CardBillingHistoryUX-div-97"
              style={{padding: "8px", background: "rgb(221, 221, 221)", display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.price}
            </div>
            <div
              id="CardBillingHistoryUX-div-98"
              style={{padding: "8px", background: "rgb(221, 221, 221)", display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.send_claim}
            </div>
            <div
              id="CardBillingHistoryUX-div-99"
              style={{padding: "8px", background: "rgb(221, 221, 221)", display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.absorb}
            </div>
            <div
              id="CardBillingHistoryUX-div-100"
              style={{padding: "8px", background: "rgb(221, 221, 221)", display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.patient_claim}
            </div>
            <div
              id="CardBillingHistoryUX-div-101"
              style={{padding: "8px", background: "rgb(221, 221, 221)", display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.non_claimable}
            </div>
            <div
              id="CardBillingHistoryUX-div-102"
              style={{padding: "8px", background: "rgb(221, 221, 221)", display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.discount}
            </div>
            <div
              id="CardBillingHistoryUX-div-103"
              style={{padding: "8px", background: "rgb(221, 221, 221)", display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.payable}
            </div>
            <div
              id="CardBillingHistoryUX-div-150"
              style={{padding: "8px", background: "rgb(221, 221, 221)", display: "flex", justifyContent: "flex-end", width: "160px", margin: "0px 20px"}}>
              {props.installment_sum}
            </div>
          </div>
          <div
            id="CardBillingHistoryUX-div-89"
            style={{display: "flex", alignItems: "center",padding: "0px 10px", justifyContent: "space-between", paddingTop: "30px", ...(props.showBillType === "credit_note" && { display: "none"})}}>
            
            <div
              id="CardBillingHistoryUX-div-112"
              style={{padding: "0px 20px"}}>
              
              <Button
                className={props.orderBy === "Mode" ? "active" : ""}
                color="teal"
                id="btn-billModeHistory"
                name="Mode"
                onClick={props.onChangeOrderBy}
                size="mini"
                style={{margin: "0px 3px"}}>
                {props.languageUX === "en" ? "BY MODE" : "หมวดสินค้า/บริการ"}
              </Button>
              <Button
                className={props.orderBy === "Order" ? "active" : ""}
                color="teal"
                id="btn-billOrderHistory"
                name="Order"
                onClick={props.onChangeOrderBy}
                size="mini"
                style={{margin: "0px 3px"}}>
                {props.languageUX === "en" ? "BY ORDER" : "ออเดอร์"}
              </Button>
              <Button
                className={props.orderBy === "Item" ? "active" : ""}
                color="teal"
                id="btn-billItemHistory"
                name="Item"
                onClick={props.onChangeOrderBy}
                size="mini"
                style={{margin: "0px 3px"}}>
                {props.languageUX === "en" ? "BY ITEM" : "รายการสินค้า/บริการ"}
              </Button>
            </div>
            <div
              id="CardBillingHistoryUX-div-113"
              style={{padding: "0px 20px", display: props.showBillType === "receipt" ? "flex" : "none", alignItems: "center"}}>
              
              <div
                id="CardBillingHistoryUX-div-226"
                style={{margin: "0px 3px", minWidth: "max-content", ...(props.isCudent && { display: "none" })}}>
                {props.languageUX === "en" ? "Doctor's name on the receipt" : "ชื่อแพทย์บนใบเสร็จ"}
              </div>
              <div
                id="CardBillingHistoryUX-div-227"
                style={{margin: "0px 3px", ...(props.isCudent && { display: "none" })}}>
                
                <Dropdown
                  disabled={true}
                  id="CardBillingHistoryUX-Dropdown-228"
                  onChange={props.onChangeDoctorName}
                  options={props.doctorNameOptions}
                  search={true}
                  selection={true}
                  value={props.doctorName}>
                </Dropdown>
              </div>
              <div
                id="CardBillingHistoryUX-div-117"
                style={{margin: "0px 3px", minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Patient name on receipt" : "ชื่อผู้ป่วยบนใบเสร็จ"}
              </div>
              <div
                id="CardBillingHistoryUX-div-124"
                style={{margin: "0px 3px"}}>
                
                <Dropdown
                  id="CardBillingHistoryUX-Dropdown-125"
                  onChange={props.onChangePatientName}
                  options={props.patientNameOptions}
                  selection={true}
                  value={props.patientName}>
                </Dropdown>
              </div>
              <div
                id="CardBillingHistoryUX-div-263">
                {props.buttonPrintCoverageDocument}
              </div>
              <div
                id="CardBillingHistoryUX-div-134"
                style={{margin: "0px 3px"}}>
                {props.buttonPrintReceipt}
              </div>
              <Button
                color="blue"
                id="btn-billDetailReportHistory"
                onClick={props.printReceipt}
                size="mini"
                style={{margin: "0px 3px"}}>
                {props.languageUX === "en" ? "Print detail sheet" : "พิมพ์ใบแสดงรายละเอียด"}
              </Button>
              <Button
                color="yellow"
                id="CardBillingHistoryUX-Button-120"
                onClick={props.confirmReceipt}
                size="mini"
                style={{margin: "0px 3px", ...(props.roleDoctor && {display: "none"})}}>
                {props.languageUX === "en" ? "Confirm rights" : "ยืนยันสิทธิ"}
              </Button>
              <Button
                color="red"
                id="btn-cancelBillHistory"
                onClick={props.cancelReceipt}
                size="mini"
                style={{margin: "0px 3px", ...(props.roleDoctor && {display: "none"}), ...(props.receiptDataStatus === "CANCELED" && {display: "none"})}}>
                {props.languageUX === "en" ? "Cancel receipt" : "ยกเลิกใบเสร็จ"}
              </Button>
            </div>
            <div
              id="CardBillingHistoryUX-div-130"
              style={{padding: "0px 20px", display: props.showBillType === "invoice" ? "flex" : "none", alignItems: "center"}}>
              
              <div
                id="CardBillingHistoryUX-div-268"
                style={{margin: "0px 3px"}}>
                {props.buttonPrintReceipt}
              </div>
              <Button
                color="blue"
                id="CardBillingHistoryUX-Button-131"
                onClick={props.printInvoice}
                size="mini"
                style={{margin: "0px 3px"}}>
                {props.languageUX === "en" ? "Print detail sheet" : "พิมพ์ใบแสดงรายละเอียด"}
              </Button>
              <Button
                color="green"
                disabled={props.hideBillPayment || false}
                id="CardBillingHistoryUX-Button-132"
                onClick={props.confirmInvoice}
                size="mini"
                style={{margin: "0px 3px", ...(props.hideBillPayment && { display: "none"})}}>
                {props.languageUX === "en" ? "Receive payment" : "รับชำระเงิน"}
              </Button>
              <Button
                color="red"
                id="CardBillingHistoryUX-Button-133"
                onClick={props.cancelInvoice}
                size="mini"
                style={{margin: "0px 3px", ...((props.receiptDataStatus === "CANCELED") && { display: "none"})}}>
                {props.languageUX === "en" ? "Cancel invoice" : "ยกเลิกใบแจ้งหนี้"}
              </Button>
            </div>
          </div>
          <div
            id="CardBillingHistoryUX-div-142"
            style={{display: "flex", alignItems: "center",padding: "10px", paddingTop: "20px", ...(props.showBillType !== "credit_note" && { display: "none"})}}>
            
            <div
              id="CardBillingHistoryUX-div-143">
              {props.languageUX === "en" ? "Refund voucher number" : "เลขที่ใบสำคัญคืนเงิน"}
            </div>
            <div
              id="CardBillingHistoryUX-div-144"
              style={{margin: "0px 8px", padding: "4px 15px", background: "rgb(221, 221, 221)", display: "flex", borderRadius: "5px "}}>
              {props.creditNoteDetail?.code}
            </div>
            <div
              id="CardBillingHistoryUX-div-145">
              {props.languageUX === "en" ? "status" : "สถานะ"}
            </div>
            <div
              id="CardBillingHistoryUX-div-146"
              style={{margin: "0px 8px", padding: "4px 15px", background: "rgb(221, 221, 221)", display: "flex", borderRadius: "5px "}}>
              {props.creditNoteDetail?.status_label}
            </div>
            <div
              id="CardBillingHistoryUX-div-147">
              {props.languageUX === "en" ? "Date-time" : "วันที่-เวลา"}
            </div>
            <div
              id="CardBillingHistoryUX-div-148"
              style={{margin: "0px 8px", padding: "4px 15px", background: "rgb(221, 221, 221)", display: "flex", borderRadius: "5px "}}>
              {props.creditNoteDetail?.editedText}
            </div>
          </div>
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.creditNoteData}
            headers="หมวด,รหัส,สินค้า,ใบเสร็จ,จำนวนรวม,ราคาต่อหน่วย,ยอดชำระ,จำนวนคืน,ยอดคืน"
            id="CardBillingHistoryUX-Table-135"
            keys="mode_code,pricing_code,pricing_name,receipts,pricing_quantity,unitprice,payable,quantity,price"
            minRows={7}
            showPagination={ false}
            style={{height: "300px",  margin: "0px 10px",  ...(props.tableOrderStyle || {}), ...(props.showBillType !== "credit_note" && { display: "none"})}}>
          </Table>
          <div
            id="CardBillingHistoryUX-div-136"
            style={{display: "flex", alignItems: "center",padding: "0px 10px 10px", justifyContent: "space-around", paddingTop: "20px", ...(props.showBillType !== "credit_note" && { display: "none"})}}>
            
            <div
              id="CardBillingHistoryUX-div-137">
              {props.languageUX === "en" ? "Total Refund" : "ยอดคืนรวม"}
            </div>
            <div
              id="CardBillingHistoryUX-div-138"
              style={{padding: "8px", background: "rgb(221, 221, 221)", display: "flex", justifyContent: "flex-end", width: "80%", margin: "0px 20px", borderRadius: "5px"}}>
              {props.price}
            </div>
            <div
              id="CardBillingHistoryUX-div-139">
              {props.buttonCancelCreditNote}
            </div>
          </div>
        </div>
        <div
          id="CardBillingHistoryUX-div-65"
          style={{width: "100%",paddingBottom: "3rem" }}>
          
        </div>
      </div>
    )
}


export default CardBillingHistoryUX

export const screenPropsDefault = {"debug":true,"language":"EN","showSupplyList":false}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ zoom: \"90%\" }"
        }
      },
      "seq": 0
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 2,
      "name": "Table",
      "parent": 63,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": ""
        },
        "data": {
          "type": "code",
          "value": "props.receiptData"
        },
        "getTdProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": "รหัสหมวด, ชื่อหมวดค่ารักษาพยาบาล, ราคา, ส่งเบิก, รพ.รับผิดชอบ, เบิกเอง, เบิกไม่ได้, ส่วนลด, ผู้ป่วยชำระ",
          "valueEN": "Mode code,Medical Mode,Price,Claim submit,absorb,Self-claim,Non-claimable,Discount,Patient pay"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Table-2"
        },
        "keys": {
          "type": "value",
          "value": "bill_mode__code,bill_mode__name,price__sum,send_claim__sum,absorb__sum,patient_claim__sum,non_claimable__sum,discount__sum,payable__sum"
        },
        "minRows": {
          "type": "code",
          "value": "7"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\", margin: \"0px 10px\",  ...(props.tableModeStyle || {}), ...(props.showBillType === \"credit_note\" && { display: \"none\"})}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการเรียกเก็บเงิน",
          "valueEN": "BILLING - HISTORY"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\",padding: \"10px 10px 0px 10px\", display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 26,
      "name": "Table",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.billingData"
        },
        "getTdProps": {
          "type": "code",
          "value": ""
        },
        "getTrProps": {
          "type": "code",
          "value": "props.onSelectedItems"
        },
        "headers": {
          "type": "value",
          "value": "ลำดับ, รหัสเอกสาร, ประเภทเอกสารค่าใช้จ่าย, ผู้ป่วย, วันที่-เวลา ออกเอกสาร, มูลค่า, สถานะ, หน่วยงาน, กะ",
          "valueEN": "No,Document code,Expense type,Patient,Document issue date,Amount,Status,Department,Shift"
        },
        "id": {
          "type": "value",
          "value": "tb-billHistory"
        },
        "keys": {
          "type": "value",
          "value": "no,code,type_name,patient_name,created,price,status_label,division_name,station_name"
        },
        "minRows": {
          "type": "code",
          "value": "7"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\",  zoom: \"87%\", margin: \"0px 10px\", ...(props.tableStyle || {})}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{display:\"none\", justifyContent:\"flex-end\",alignItems:\"center\", padding: \"10px 0px 20px 0px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Checkbox",
      "parent": 28,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.divisionCheck"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Checkbox-29"
        },
        "label": {
          "type": "value",
          "value": "หน่วยงาน",
          "valueEN": "Agency"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDivisionCheck"
        },
        "onClick": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding:\"0px 10px\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{display: props?.searchHistorySelected  ? \"flex\" :\"none\" ,alignItems:\"center\", margin: \"10px 10px\", fontWeight: \"normal\", fontSize: \"1.2rem\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่เอกสาร",
          "valueEN": "Document number"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px 0px 0px\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "encounter",
          "valueEN": "encounter"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px 0px 30px\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์",
          "valueEN": "physician"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px 0px 30px\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานสั่ง",
          "valueEN": "Ordered agency"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px 0px 30px\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานจ่าย",
          "valueEN": "Paying agency"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px 0px 30px\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Label",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editCode"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Label-51"
        },
        "name": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Label",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editEncounter"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Label-52"
        },
        "name": {
          "type": "code",
          "value": "{margin: \"0px 20px 0px 0px\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Label",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Label-53"
        },
        "name": {
          "type": "code",
          "value": "{margin: \"0px 20px 0px 0px\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Label",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editOrderDiv"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Label-54"
        },
        "name": {
          "type": "code",
          "value": "{margin: \"0px 20px 0px 0px\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Label",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editOrderPerformDiv"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Label-55"
        },
        "name": {
          "type": "code",
          "value": "{margin: \"0px 20px 0px 0px\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showBillType === \"credit_note\" ? \"CREDIT NOTE\" :  props.showBillType === \"invoice\" ? \"INVOICE\" : props.showBillType === \"receipt\" ? \"RECEIPT\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\",padding: \"10px\", display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showBillType === \"credit_note\" ? \"ข้อมูลรายการใบสำคัญคืนเงิน\" :  \"ข้อมูลใบเสร็จค่ารักษาพยาบาล\""
        },
        "className": {
          "type": "value",
          "value": "ข้อมูลใบเสร็จค่ารักษาพยาบาล",
          "valueEN": "Receipt Information"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-62"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\", display: props.receiptId === \"\" ?  \"none\" : \"block\", ...(props.selectedReceipt?.type_name === \"DEPOSIT\" && { display: \"none\" }) }"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",paddingBottom: \"3rem\" }"
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการชำระเงินค่ารักษาพยาบาล",
          "valueEN": "Medical payment history"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-72"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "Checkbox",
      "parent": 28,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.statusCheck"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Checkbox-75"
        },
        "label": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStatusCheck"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"0px 5px\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Checkbox",
      "parent": 28,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.dateCheck"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Checkbox-78"
        },
        "label": {
          "type": "value",
          "value": "วันที่ออกเอกสาร",
          "valueEN": "Document issue date"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDateCheck"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"0px 5px\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 79,
      "name": "DateTextBox",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-DateTextBox-79"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"0px 5px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.startDate"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 80,
      "name": "DateTextBox",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-DateTextBox-80"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDate"
        },
        "placeholder": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding:\"0px 5px\",}"
        },
        "value": {
          "type": "code",
          "value": "props.endDate"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-81"
        },
        "style": {
          "type": "code",
          "value": "{width: \"170px\", margin: \"0px 5px\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "Dropdown",
      "parent": 81,
      "props": {
        "fluid": {
          "type": "value",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Dropdown-82"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDivision"
        },
        "options": {
          "type": "code",
          "value": "props.division"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.divisionSelect"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-83"
        },
        "style": {
          "type": "code",
          "value": "{width: \"170px\", margin: \"0px 5px\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-84"
        },
        "style": {
          "type": "code",
          "value": "{width: \"170px\", margin: \"0px 5px\"}"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "Dropdown",
      "parent": 83,
      "props": {
        "fluid": {
          "type": "value",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Dropdown-85"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStatus"
        },
        "options": {
          "type": "code",
          "value": "props.statusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.status"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "Dropdown",
      "parent": 84,
      "props": {
        "fluid": {
          "type": "value",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-billingType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeType"
        },
        "options": {
          "type": "code",
          "value": "props.typeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.type"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",padding: \"0px 10px\", justifyContent: \"space-around\", paddingTop: \"20px\", ...(props.showBillType === \"credit_note\" && { display: \"none\"})}"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",padding: \"0px 10px\", justifyContent: \"space-around\", ...(props.showBillType === \"credit_note\" && { display: \"none\"})}"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",padding: \"0px 10px\", justifyContent: \"space-between\", paddingTop: \"30px\", ...(props.showBillType === \"credit_note\" && { display: \"none\"})}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคารวม",
          "valueEN": "Total price"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งเบิก",
          "valueEN": "Claim submit"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": "รพ.รับผิดชอบ",
          "valueEN": "absorb"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกเอง",
          "valueEN": "Self-Claim"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกไม่ได้",
          "valueEN": "Non-claimable"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนลด",
          "valueEN": "Discount"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วยชำระ",
          "valueEN": "Patient pay"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "code",
          "value": "props.price"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"8px\", background: \"rgb(221, 221, 221)\", display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "code",
          "value": "props.send_claim"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"8px\", background: \"rgb(221, 221, 221)\", display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "code",
          "value": "props.absorb"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-99"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"8px\", background: \"rgb(221, 221, 221)\", display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patient_claim"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-100"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"8px\", background: \"rgb(221, 221, 221)\", display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "code",
          "value": "props.non_claimable"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-101"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"8px\", background: \"rgb(221, 221, 221)\", display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "code",
          "value": "props.discount"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-102"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"8px\", background: \"rgb(221, 221, 221)\", display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "code",
          "value": "props.payable"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"8px\", background: \"rgb(221, 221, 221)\", display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-112"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 20px\"}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 113,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-113"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 20px\", display: props.showBillType === \"receipt\" ? \"flex\" : \"none\", alignItems: \"center\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "Button",
      "parent": 112,
      "props": {
        "children": {
          "type": "value",
          "value": "หมวดสินค้า/บริการ",
          "valueEN": "BY MODE"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Mode\" ? \"active\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "btn-billModeHistory"
        },
        "name": {
          "type": "value",
          "value": "Mode"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeOrderBy"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\"}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "Button",
      "parent": 112,
      "props": {
        "children": {
          "type": "value",
          "value": "ออเดอร์",
          "valueEN": "BY ORDER"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Order\" ? \"active\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "btn-billOrderHistory"
        },
        "name": {
          "type": "value",
          "value": "Order"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeOrderBy"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "Button",
      "parent": 112,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการสินค้า/บริการ",
          "valueEN": "BY ITEM"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Item\" ? \"active\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "btn-billItemHistory"
        },
        "name": {
          "type": "value",
          "value": "Item"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeOrderBy"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\"}"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้ป่วยบนใบเสร็จ",
          "valueEN": "Patient name on receipt"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-117"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "Button",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ใบแสดงรายละเอียด",
          "valueEN": "Print detail sheet"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "btn-billDetailReportHistory"
        },
        "onClick": {
          "type": "code",
          "value": "props.printReceipt"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\"}"
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "Button",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยันสิทธิ",
          "valueEN": "Confirm rights"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Button-120"
        },
        "onClick": {
          "type": "code",
          "value": "props.confirmReceipt"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\", ...(props.roleDoctor && {display: \"none\"})}"
        }
      },
      "seq": 262,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "Button",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกใบเสร็จ",
          "valueEN": "Cancel receipt"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "btn-cancelBillHistory"
        },
        "onClick": {
          "type": "code",
          "value": "props.cancelReceipt"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\", ...(props.roleDoctor && {display: \"none\"}), ...(props.receiptDataStatus === \"CANCELED\" && {display: \"none\"})}"
        }
      },
      "seq": 263,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 122,
      "name": "Table",
      "parent": 63,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.receiptData"
        },
        "getTheadThProps": {
          "type": "code",
          "value": ""
        },
        "getTrProps": {
          "type": "code",
          "value": "props.byOrderRowProps"
        },
        "headers": {
          "type": "value",
          "value": "แผนก, ชื่อรายการคำสั่ง, ประเภท, วันที่และเวลาค่าใช้จ่าย, ราคา, ส่งเบิก, รพ.รับผิดชอบ, เบิกเอง, เบิกไม่ได้, ส่วนลด, ผู้ป่วยชำระ, ประเภทค่าใช้จ่าย, สถานะค่าใช้จ่าย,หมายเลขรับบริการ",
          "valueEN": "Division,Order,Type,Expense Datetime, Price,Claim submit, Absorb,Self-claim,Non-claimable,Discount,Patient pay, Expense type,Expense status,Encounter"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Table-122"
        },
        "keys": {
          "type": "value",
          "value": "division__name, display_name, encounter__type, created, price__sum, send_claim__sum, absorb__sum, patient_claim__sum, non_claimable__sum, discount__sum, payable__sum , type__name, status__name, encounter__number"
        },
        "minRows": {
          "type": "code",
          "value": "7"
        },
        "showPagination": {
          "type": "code",
          "value": " false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\",  margin: \"0px 10px\",  ...(props.tableOrderStyle || {}), ...(props.showBillType === \"credit_note\" && { display: \"none\"})}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 123,
      "name": "Table",
      "parent": 63,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.receiptData"
        },
        "headers": {
          "type": "value",
          "value": "รหัสหมวด, รหัสค่ารักษา, ชื่อรายการค่ารักษาพยาบาล, จำนวน, ราคาต่อหน่วย, ราคา, ส่งเบิก, absorb, เบิกเอง, เบิกไม่ได้, ส่วนลด, ผู้ป่วยชำระ, ส่วนลดสิทธิ, รหัสส่วนลด",
          "valueEN": "Mode code, item code,Name,QTY,Price/Unit,Total Price,Claim submit, Absorb,Self-claim,Non-claimable,Discount,Patient pay, Discount Policy,Discount code"
        },
        "id": {
          "type": "value",
          "value": "tb-billHistoryDetails"
        },
        "keys": {
          "type": "value",
          "value": "mode_code, code, product, quantity, unitprice, price__sum, send_claim__sum, absorb__sum, patient_claim__sum, non_claimable__sum, discount__sum, payable__sum, drg_discount_amount, discount_code"
        },
        "minRows": {
          "type": "code",
          "value": "7"
        },
        "showPagination": {
          "type": "code",
          "value": " false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\",  margin: \"0px 10px\",  ...(props.tableItemStyle || {}), ...(props.showBillType === \"credit_note\" && { display: \"none\"})}"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-124"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\"}"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "Dropdown",
      "parent": 124,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Dropdown-125"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePatientName"
        },
        "options": {
          "type": "code",
          "value": "props.patientNameOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.patientName"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-126"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\"}"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 127,
      "name": "Table",
      "parent": 126,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.edcData"
        },
        "headers": {
          "type": "value",
          "value": "Referral Code,Approval Code,Perform Date\t,Type,Status,Total Price,Actual Price,Actions"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Table-127"
        },
        "keys": {
          "type": "value",
          "value": "reference_code_edited,approval_code_edited,effective_date,approval_type,status,total_price,actual_price,actions"
        },
        "minRows": {
          "type": "code",
          "value": "7"
        },
        "showPagination": {
          "type": "code",
          "value": " false"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showEDC ? \"\" : \"none\", height: \"300px\",  zoom: \"100%\", margin: \"0px 10px\"}"
        },
        "widths": {
          "type": "value",
          "value": "auto,auto,auto,auto,auto,auto,auto,220"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-128"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 10px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "hr",
      "parent": 128,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-hr-129"
        }
      },
      "seq": 129,
      "void": true
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 20px\", display: props.showBillType === \"invoice\" ? \"flex\" : \"none\", alignItems: \"center\"}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 131,
      "name": "Button",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ใบแสดงรายละเอียด",
          "valueEN": "Print detail sheet"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Button-131"
        },
        "onClick": {
          "type": "code",
          "value": "props.printInvoice"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\"}"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "Button",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "รับชำระเงิน",
          "valueEN": "Receive payment"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.hideBillPayment || false"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Button-132"
        },
        "onClick": {
          "type": "code",
          "value": "props.confirmInvoice"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\", ...(props.hideBillPayment && { display: \"none\"})}"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "Button",
      "parent": 130,
      "props": {
        "basic": {
          "type": "code",
          "value": ""
        },
        "children": {
          "type": "value",
          "value": "ยกเลิกใบแจ้งหนี้",
          "valueEN": "Cancel invoice"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Button-133"
        },
        "onClick": {
          "type": "code",
          "value": "props.cancelInvoice"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\", ...((props.receiptDataStatus === \"CANCELED\") && { display: \"none\"})}"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrintReceipt"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-134"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\"}"
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 135,
      "name": "Table",
      "parent": 63,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.creditNoteData"
        },
        "headers": {
          "type": "value",
          "value": "หมวด,รหัส,สินค้า,ใบเสร็จ,จำนวนรวม,ราคาต่อหน่วย,ยอดชำระ,จำนวนคืน,ยอดคืน"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Table-135"
        },
        "keys": {
          "type": "value",
          "value": "mode_code,pricing_code,pricing_name,receipts,pricing_quantity,unitprice,payable,quantity,price"
        },
        "minRows": {
          "type": "code",
          "value": "7"
        },
        "showPagination": {
          "type": "code",
          "value": " false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\",  margin: \"0px 10px\",  ...(props.tableOrderStyle || {}), ...(props.showBillType !== \"credit_note\" && { display: \"none\"})}"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",padding: \"0px 10px 10px\", justifyContent: \"space-around\", paddingTop: \"20px\", ...(props.showBillType !== \"credit_note\" && { display: \"none\"})}"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดคืนรวม",
          "valueEN": "Total Refund"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-137"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "code",
          "value": "props.price"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-138"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"8px\", background: \"rgb(221, 221, 221)\", display: \"flex\", justifyContent: \"flex-end\", width: \"80%\", margin: \"0px 20px\", borderRadius: \"5px\"}"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonCancelCreditNote"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-139"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-142"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",padding: \"10px\", paddingTop: \"20px\", ...(props.showBillType !== \"credit_note\" && { display: \"none\"})}"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบสำคัญคืนเงิน",
          "valueEN": "Refund voucher number"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-143"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": null,
      "id": 144,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "code",
          "value": "props.creditNoteDetail?.code"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-144"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 8px\", padding: \"4px 15px\", background: \"rgb(221, 221, 221)\", display: \"flex\", borderRadius: \"5px \"}"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": null,
      "id": 145,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-145"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "code",
          "value": "props.creditNoteDetail?.status_label"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-146"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 8px\", padding: \"4px 15px\", background: \"rgb(221, 221, 221)\", display: \"flex\", borderRadius: \"5px \"}"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่-เวลา",
          "valueEN": "Date-time"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-147"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "code",
          "value": "props.creditNoteDetail?.editedText"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-148"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 8px\", padding: \"4px 15px\", background: \"rgb(221, 221, 221)\", display: \"flex\", borderRadius: \"5px \"}"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": "ผ่อนชำระ",
          "valueEN": "Installment"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-149"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "code",
          "value": "props.installment_sum"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-150"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"8px\", background: \"rgb(221, 221, 221)\", display: \"flex\", justifyContent: \"flex-end\", width: \"160px\", margin: \"0px 20px\"}"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 151,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-151"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px 10px\", ...(props.selectedReceipt?.type_name !== \"PAYMENT\" && { display: \"none\" })  }"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 152,
      "name": "Form",
      "parent": 151,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Form-152"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 153,
      "name": "FormGroup",
      "parent": 152,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormGroup-153"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\" }"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "FormField",
      "parent": 153,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-155"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 156,
      "name": "FormField",
      "parent": 153,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-156"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "FormField",
      "parent": 153,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-157"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "FormField",
      "parent": 153,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-158"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "FormField",
      "parent": 153,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-159"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "FormField",
      "parent": 153,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-160"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบเสร็จ",
          "valueEN": "Receipt number"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-167"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", marginRight: \"10px\" }"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะเอกสาร",
          "valueEN": "Document status"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-168"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", margin: \"0px 10px\" }"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "div",
      "parent": 157,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่-เวลา",
          "valueEN": "Date-time"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-169"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", margin: \"0px 10px\" }"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 170,
      "name": "div",
      "parent": 158,
      "props": {
        "children": {
          "type": "value",
          "value": "Encounter",
          "valueEN": "Encounter"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-170"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", margin: \"0px 10px\" }"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "div",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": "Station",
          "valueEN": "Station"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-171"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", margin: \"0px 10px\" }"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "div",
      "parent": 160,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงาน",
          "valueEN": "Agency"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-172"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", margin: \"0px 10px\" }"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 185,
      "name": "FormGroup",
      "parent": 152,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormGroup-185"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\" }"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 186,
      "name": "FormField",
      "parent": 185,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-186"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 187,
      "name": "FormField",
      "parent": 185,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-187"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 188,
      "name": "FormField",
      "parent": 185,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-188"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 189,
      "name": "FormField",
      "parent": 185,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-189"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 190,
      "name": "FormField",
      "parent": 185,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-190"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 191,
      "name": "FormField",
      "parent": 185,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-191"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "div",
      "parent": 191,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedReceipt?.station_name"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-192"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", background: \"rgb(221, 221, 221)\", padding: \"3px 10px\", margin: \"0px 10px\" }"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": null,
      "id": 193,
      "name": "div",
      "parent": 190,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedReceipt?.status_label"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-193"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", background: \"rgb(221, 221, 221)\", padding: \"3px 10px\", margin: \"0px 10px\" }"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": null,
      "id": 194,
      "name": "div",
      "parent": 189,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedReceipt?.created"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-194"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", background: \"rgb(221, 221, 221)\", padding: \"3px 10px\", margin: \"0px 10px\" }"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": null,
      "id": 195,
      "name": "div",
      "parent": 188,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedReceipt?.division_name"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-195"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", background: \"rgb(221, 221, 221)\", padding: \"3px 10px\", margin: \"0px 10px\" }"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": null,
      "id": 196,
      "name": "div",
      "parent": 187,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedReceipt?.encounter_no || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-196"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", background: \"rgb(221, 221, 221)\", padding: \"3px 10px\", margin: \"0px 10px\" }"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": null,
      "id": 197,
      "name": "div",
      "parent": 186,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedReceipt?.code"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-197"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", background: \"rgb(221, 221, 221)\", padding: \"3px 10px\", marginRight: \"10px\" }"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": null,
      "id": 198,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-198"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px 10px\", ...(props.selectedReceipt?.type_name !== \"FULL_PAYMENT\" && { display: \"none\" })  }"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 199,
      "name": "Form",
      "parent": 198,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Form-199"
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 200,
      "name": "FormGroup",
      "parent": 199,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormGroup-200"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\" }"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 201,
      "name": "FormGroup",
      "parent": 199,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormGroup-201"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\" }"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 202,
      "name": "FormField",
      "parent": 200,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-202"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 203,
      "name": "FormField",
      "parent": 200,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-203"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 204,
      "name": "FormField",
      "parent": 200,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-204"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 205,
      "name": "FormField",
      "parent": 200,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-205"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 206,
      "name": "FormField",
      "parent": 200,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-206"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 206,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 207,
      "name": "FormField",
      "parent": 200,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-207"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 207,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 208,
      "name": "FormField",
      "parent": 201,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-208"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 209,
      "name": "FormField",
      "parent": 201,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-209"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 210,
      "name": "FormField",
      "parent": 201,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-210"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 210,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 211,
      "name": "FormField",
      "parent": 201,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-211"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 211,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 212,
      "name": "FormField",
      "parent": 201,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-212"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 213,
      "name": "FormField",
      "parent": 201,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-213"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": null,
      "id": 214,
      "name": "div",
      "parent": 213,
      "props": {
        "children": {
          "type": "code",
          "value": "props.receiptEncounterData?.checkOut || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-214"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", background: \"rgb(221, 221, 221)\", padding: \"3px 10px\", margin: \"0px 10px\" }"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": null,
      "id": 215,
      "name": "div",
      "parent": 212,
      "props": {
        "children": {
          "type": "code",
          "value": "props.receiptEncounterData?.checkIn || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-215"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", background: \"rgb(221, 221, 221)\", padding: \"3px 10px\", margin: \"0px 10px\" }"
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": null,
      "id": 216,
      "name": "div",
      "parent": 211,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedReceipt?.encounter_no"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-216"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", background: \"rgb(221, 221, 221)\", padding: \"3px 10px\", margin: \"0px 10px\" }"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": null,
      "id": 217,
      "name": "div",
      "parent": 210,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedReceipt?.created"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-217"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", background: \"rgb(221, 221, 221)\", padding: \"3px 10px\", margin: \"0px 10px\" }"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": null,
      "id": 218,
      "name": "div",
      "parent": 209,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedReceipt?.status_label"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-218"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", background: \"rgb(221, 221, 221)\", padding: \"3px 10px\", margin: \"0px 10px\" }"
        }
      },
      "seq": 218,
      "void": false
    },
    {
      "from": null,
      "id": 219,
      "name": "div",
      "parent": 208,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedReceipt?.code"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-219"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", background: \"rgb(221, 221, 221)\", padding: \"3px 10px\", marginRight: \"10px\" }"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": null,
      "id": 220,
      "name": "div",
      "parent": 207,
      "props": {
        "children": {
          "type": "value",
          "value": "จำหน่าย",
          "valueEN": "For sale"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-220"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", margin: \"0px 10px\" }"
        }
      },
      "seq": 220,
      "void": false
    },
    {
      "from": null,
      "id": 221,
      "name": "div",
      "parent": 206,
      "props": {
        "children": {
          "type": "value",
          "value": "รับเข้า",
          "valueEN": "Admission"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-221"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", margin: \"0px 10px\" }"
        }
      },
      "seq": 221,
      "void": false
    },
    {
      "from": null,
      "id": 222,
      "name": "div",
      "parent": 205,
      "props": {
        "children": {
          "type": "value",
          "value": "Encounter",
          "valueEN": "Encounter"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-222"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", margin: \"0px 10px\" }"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": null,
      "id": 223,
      "name": "div",
      "parent": 204,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่-เวลา",
          "valueEN": "Date-time"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-223"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", margin: \"0px 10px\" }"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": null,
      "id": 224,
      "name": "div",
      "parent": 203,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-224"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", margin: \"0px 10px\" }"
        }
      },
      "seq": 224,
      "void": false
    },
    {
      "from": null,
      "id": 225,
      "name": "div",
      "parent": 202,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบเสร็จ",
          "valueEN": "Receipt number"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-225"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", marginRight: \"10px\" }"
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": null,
      "id": 226,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อแพทย์บนใบเสร็จ",
          "valueEN": "Doctor's name on the receipt"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-226"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\", minWidth: \"max-content\", ...(props.isCudent && { display: \"none\" })}"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 227,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-227"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\", ...(props.isCudent && { display: \"none\" })}"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 228,
      "name": "Dropdown",
      "parent": 227,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Dropdown-228"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDoctorName"
        },
        "options": {
          "type": "code",
          "value": "props.doctorNameOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.doctorName"
        }
      },
      "seq": 228,
      "void": false
    },
    {
      "from": null,
      "id": 229,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-229"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": null,
      "id": 230,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "code",
          "value": "props.formStyle"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-230"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", margin: \"0rem 1rem 1rem\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 231,
      "name": "FormGroup",
      "parent": 245,
      "props": {
        "className": {
          "type": "value",
          "value": "rps-form-group"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormGroup-231"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 232,
      "name": "FormField",
      "parent": 231,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-232"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 233,
      "name": "FormField",
      "parent": 231,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-233"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 4 : 2"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 234,
      "name": "FormField",
      "parent": 231,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-234"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 235,
      "name": "FormField",
      "parent": 231,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-235"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 3 : 2"
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 236,
      "name": "FormField",
      "parent": 231,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-236"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 4 : 2"
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 237,
      "name": "FormField",
      "parent": 231,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-237"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 238,
      "name": "FormField",
      "parent": 231,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-238"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 5 : 2"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 239,
      "name": "FormField",
      "parent": 231,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-239"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 5 : 2"
        }
      },
      "seq": 264,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 240,
      "name": "FormField",
      "parent": 231,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-240"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 242,
      "name": "Checkbox",
      "parent": 232,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.divisionCheck"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Checkbox-242"
        },
        "label": {
          "type": "value",
          "value": "หน่วยงาน",
          "valueEN": "Department"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDivisionCheck"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 244,
      "name": "Dropdown",
      "parent": 233,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Dropdown-244"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDivision"
        },
        "options": {
          "type": "code",
          "value": "props.division"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.divisionSelect"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 245,
      "name": "Form",
      "parent": 230,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Form-245"
        }
      },
      "seq": 245,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 247,
      "name": "Checkbox",
      "parent": 234,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.statusCheck"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Checkbox-247"
        },
        "label": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStatusCheck"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": null,
      "id": 251,
      "name": "div",
      "parent": 238,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-251"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 251,
      "void": false
    },
    {
      "from": null,
      "id": 252,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-252"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 254,
      "name": "Dropdown",
      "parent": 235,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Dropdown-254"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStatus"
        },
        "options": {
          "type": "code",
          "value": "props.statusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.status"
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 255,
      "name": "Dropdown",
      "parent": 236,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-billingType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeType"
        },
        "options": {
          "type": "code",
          "value": "props.typeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.type"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 256,
      "name": "Checkbox",
      "parent": 237,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.dateCheck"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Checkbox-256"
        },
        "label": {
          "type": "value",
          "value": "วันที่ออกเอกสาร",
          "valueEN": "Document  date"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDateCheck"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": null,
      "id": 259,
      "name": "div",
      "parent": 240,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-259"
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 260,
      "name": "DateTextBox",
      "parent": 251,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-DateTextBox-260"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.startDate"
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 261,
      "name": "DateTextBox",
      "parent": 252,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-DateTextBox-261"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDate"
        },
        "value": {
          "type": "code",
          "value": "props.endDate"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": null,
      "id": 263,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrintCoverageDocument"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-263"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 264,
      "name": "FormField",
      "parent": 231,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-264"
        },
        "inline": {
          "type": "value",
          "value": "true"
        }
      },
      "seq": 232,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 265,
      "name": "FormField",
      "parent": 231,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-FormField-265"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 4 : 2"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 266,
      "name": "Checkbox",
      "parent": 264,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.codeCheck"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Checkbox-266"
        },
        "label": {
          "type": "value",
          "value": "รหัสเอกสาร",
          "valueEN": "Document code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCodeCheck"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 267,
      "name": "Input",
      "parent": 265,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-Input-267"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCode"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.code"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": null,
      "id": 268,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrintReceipt"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryUX-div-268"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 3px\"}"
        }
      },
      "seq": 131,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardBillingHistoryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "debug": true,
    "language": "EN",
    "showSupplyList": false
  },
  "width": 80
}

*********************************************************************************** */
